<template lang='pug'>
  div(v-if='log')
    v-tooltip(bottom v-if='long')
      template(v-slot:activator='{on}')
        .text-caption.font-weight-light.text-truncate(v-on='on' v-html='log')
      span(v-html='log')
    .text-caption.font-weight-light.text-truncate(v-if='!long' v-html='log')
</template>

<script>
export default {
  name: 'BionicMetricsLogPreview',
  props: {
    log: {
      type: String
    }
  },
  computed: {
    long() {
      return this.log && this.log.length > 100;
    }
  }
};
</script>

<style scoped>
</style>
